(function( $ ){
    var o = $( {} );
    $.subscribe   = function(types, selector, data, fn){};
    $.publish     = function(type, data){};
    $.unsubscribe = function(types, selector, fn){};
    $.each(
        { on: 'subscribe', trigger: 'publish', off: 'unsubscribe'},
        function( key, api ) {
            $[api] = function() { o[key].apply( o, arguments ); }
        }
    );
})( jQuery );

function createCookie(name,value,days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	}else{
		var expires = "";
	}
	document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
	var nameEQ = name + "=",
	ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

function arrayKeys(array) {

    var result = [];

    for (var i in array) {
        if (array.hasOwnProperty(i)) {
            result.push(i);
        }
    }

    return result;
}

$(function() {

	$('#tog').click(function(){

		var container = $('#toggle_all_i');
		if(container.css('display')!='block')
		{
			$('#toggle_all_i form').submit(function(){
				var form = $(this);
				$.post(form.attr('action'),{text:form.find('textarea').val(),js:true},
				function(data){
					form.children('div').remove();
					form.children('p').text(data);
				});
				return false;
			});
			container.show();
		}else{
			container.hide();
		}

	});

    $('#hoverZone').hover(toggleCandle,toggleCandle);
	
});

function toggleCandle() {

		var offClass = 'off';
		if($('#centerCandle').hasClass(offClass))
		{
			$('.'+offClass).removeClass(offClass);

		}else{
			$('#centerCandle').addClass(offClass);
			$('#leftCandle').addClass(offClass);
			$('#rightCandle').addClass(offClass);
		}

}

/**
 * ������� ���������/������� ���������
 * @param a
 * @param t
 * @constructor
 */
function VotingUp(a, t){

    $comment = $(a).closest('.comment-holder');

    if ($comment.length) {

        $.ajax({
            type: 'post',
            url: 'http://' + window.location.host + '/up_down_comments',
            dataType: 'json',
            data: {
                comment : $comment.data('id'),
                vote : t,
                againstCount : $comment.attr('data-vote-against')
            },
            success: function(response) {
                if(!response.success) {
                    $("#comment-"+id).replaceWith(response.message);
                }
                else {
                    $comment.attr('data-vote-against', response.vote_against_count);
                    $comment.css({color : 'rgb(' + response.vote_against_color.join(',') + ')'})
                    if (t == 1) {
                        var voteForCount = parseInt($comment.attr('data-vote-for')) + 1;
                        if ([100, 200, 300].indexOf(voteForCount) !== -1) {
                            window.location.reload();
                        }
                        $comment.attr('data-vote-for', voteForCount);
                    }
                }
            }
        });
    }

}

// successCallback: (data.data, data.total, data.message, param)
// failureCallback: (failureMsg, param, data)
var jsonRequest2 = function(parameters) {
	var url = parameters.url;
	var method = parameters.method || 'GET';
	var data = parameters.data;
	var successCallback = parameters.successCallback;
	var failureCallback = parameters.failureCallback;
	var scope = parameters.scope;
	var param = parameters.param;
	var progressElement = parameters.progressElement;
	if (progressElement) {
		$(progressElement).addClass('ajax-progress');
	}
	if (url && url[0] != '/') {
		var check = location.protocol + '//' + location.hostname;
		var useJsonp = (url.substr(0, check.length) != check);
	} else {
		var useJsonp = false;
	}

	var successProc = function(retData, status, xhr) {
		if (progressElement) {
			$(progressElement).removeClass('ajax-progress');
		}
		var failureMsg = '';
		try {
			if (retData) {
				if (!retData.success) {
					failureMsg = (retData.message ? retData.message : '����������� ������');
				} else if (retData.data !== undefined) {
					// data format is valid
					try {
						successCallback.call(scope || window, retData.data, retData.total, retData.message, param);
					} catch (e) {
						failureMsg = '������ ��������� ������: ' + e.toString();
					}
				} else {
					failureMsg = '������������ ������ ������ �������';
				}
			} else {
				failureMsg = '������������ ������ ������ �������';
			}
		} catch (e){
			failureMsg = '������ ��������� �������: ' + e.toString();
		}
		if (failureMsg) {
			if (failureCallback) {
				failureCallback.call(scope || window, failureMsg, param, retData);
			} else {
//				alert(failureMsg);
			}
		}
	};

	var failureProc = function(xhr, statusText, err) {
		try {
			if (failureCallback) {
				failureCallback.call(scope || window, "�� ������� ��������� ������:\n" + xhr.status + ' (' + xhr.statusText + ')', param, null);
			}
		} catch (e) {
//			console.log(e);
		}
		if (progressElement) {
			$(progressElement).removeClass('ajax-progress');
		}
	};

	$.ajax({
		url: (method == 'GET') ? url + '?_dc=' + Math.random() : url,
		type: method,
		error: failureProc,
		data: (method == 'GET') ? data : JSON.stringify(data),
		dataType: useJsonp ? 'jsonp' : 'json',
		jsonp: useJsonp ? undefined : false,
		processData: (method == 'GET'),
		success: successProc
	});
};